import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { toast, Toaster } from "react-hot-toast";

const MultipleLocationSuperMarketModal = ({
  isOpen,
  onClose,
  fromDate,
  onDataSubmit,
  dataUrl,
  toDate,
  onPendingChange,
}) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedLocationIDs, setSelectedLocationIDs] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [pending, setPending] = useState(false);
  const adminInfo = JSON.parse(sessionStorage.getItem("adminInfo") || "{}");
  const token = sessionStorage.getItem("token");
  const [apiError, setApiError] = useState("");

  const toastStyle = {
    fontFamily: "QSemiBold",
    fontSize: "14px",
    fontWeight: 500,
  };

  
  

  const fetchUserLocations = async () => {
    if (!token) throw new Error("Missing token");

    let endpoint = "";
    const adminId = adminInfo?.id;
    if (!adminId) throw new Error("Missing admin ID");

    endpoint = `${process.env.REACT_APP_BACKEND_API_URL}/user/selectedLocation/${adminId}`;

    const { data } = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return data;
  };

  const {
    data = {},
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["userLocations"],
    queryFn: fetchUserLocations,
    enabled: isOpen,
  });

  const locations = data?.data || [];

  const isMutipleLocationIDs = adminInfo?.multiple_location;

  useEffect(() => {
    if (!isOpen) {
      setSelectedLocation(null);
      setSelectedLocationIDs([]);
    }
  }, [isOpen]);

  const handleCheckboxChange = (id) => {
    setSelectedLocationIDs((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };


 
 

  useEffect(() => {
    const fetchDataOnFromDateChange = async () => {
      if (isOpen || !fromDate || isMutipleLocationIDs.length === 0) return;
      setPending(true);
      onPendingChange?.(true);
      try {
        const token = sessionStorage.getItem("token");
        const selectedLocationID = JSON.parse(
          sessionStorage.getItem("selectedLocation")
        );
        const selectedLocation = JSON.parse(
          sessionStorage.getItem("locations") || "[]"
        );

        const isoDate = new Date(fromDate).toISOString();

        const requestBody = {
          id: selectedLocationID || "",
          dataurl: `/api/${dataUrl}`,
          subdata: {
            Loations: selectedLocation || [],
            fromDate: isoDate,
            toDate: isoDate,
          },
        };

        const { data } = await axios.post(
          `${process.env.REACT_APP_BACKEND_API_URL}/clients/multipleLocations-summarydetails`,
          requestBody,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const datas = data?.result;
        const summary = data?.result?.summary || [];
        const locationWise = data?.result?.locationWise || [];

        if (onDataSubmit) {
          onDataSubmit({ summary, locationWise, datas, pending });
        }
      } catch (error) {
        console.error("Error fetching data on date change:", error);
      } finally {
        setPending(false);
        onPendingChange?.(false);
      }
    };

    fetchDataOnFromDateChange();
  }, [fromDate, isOpen]);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    setApiError("");
    try {
      const token = sessionStorage.getItem("token");

      if (
        !selectedLocation ||
        !token ||
        !fromDate ||
        selectedLocationIDs.length === 0
      ) {
        throw new Error("Missing required data");
      }

      const isoDate = new Date(fromDate).toISOString();
      const isoToDate = new Date(toDate).toISOString();

      const requestBody = {
        id: selectedLocation._id,
        dataurl: `/api/${dataUrl}`,
        subdata: {
          Loations: selectedLocationIDs,
          fromDate: isoDate,
          toDate: isoToDate,
        },
      };

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_API_URL}/clients/multipleLocations-summarydetails`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Save client settings
      if (data?.client?.appSettings) {
        sessionStorage.setItem(
          "clientSettings",
          JSON.stringify(data.client.appSettings)
        );
      }

      sessionStorage.setItem(
        "selectedLocation",
        JSON.stringify(selectedLocation._id)
      );
      sessionStorage.setItem("locations", JSON.stringify(selectedLocationIDs));
      const summary = data?.result?.summary || [];
      const locationWise = data?.result?.locationWise || [];

      if (onDataSubmit) {
        onDataSubmit({ summary, locationWise });
      }

      onClose();
    } catch (error) {
      setApiError("Can't Get Data From this location !");
      toast.error("Somthing Went Wrong !", {
        style: toastStyle,
      });
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 40 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 40 }}
            transition={{ type: "spring", stiffness: 250, damping: 20 }}
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-lg space-y-4"
          >
            <h2 className="text-2xl font-semibold font-QSemiBold text-gray-800 whitespace-nowrap">
              Select a Location
            </h2>

            <div className="max-h-96 overflow-y-auto pr-2">
              {isLoading ? (
                <p className="text-gray-600">Loading locations...</p>
              ) : isError ? (
                <p className="text-red-500">Error: {error.message}</p>
              ) : Array.isArray(locations?.selected_location) &&
                locations.selected_location.length > 0 ? (
                locations.selected_location.map((loc, index) => (
                  <motion.div
                    key={index}
                    className="mb-4"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.05 }}
                  >
                    <div className="flex items-center mb-2">
                      <input
                        type="radio"
                        id={`location-${index}`}
                        name="location"
                        value={loc.locationEndPoint._id}
                        checked={
                          selectedLocation?._id === loc.locationEndPoint._id
                        }
                        onChange={() => {
                         
                          
                          setSelectedLocation(loc.locationEndPoint);
                          const allLocationIds = (loc.locationID || []).map(
                            (l) => l.id
                          );
                          setSelectedLocationIDs(allLocationIds);
                        }}
                        className="mr-2 accent-blue-600"
                      />
                      <label
                        htmlFor={`location-${index}`}
                        className="font-QSemiBold text-gray-800 whitespace-nowrap"
                      >
                        {loc.locationEndPoint.endpoint_name}
                      </label>
                    </div>

                    {selectedLocation?._id === loc.locationEndPoint._id &&
                      Array.isArray(loc.locationID) &&
                      loc.locationID.length > 0 && (
                        <div className="ml-6 space-y-2">
                          {loc.locationID.map((location, i) => (
                            <motion.div
                              key={i}
                              className="flex items-center"
                              initial={{ opacity: 0, x: -10 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ delay: i * 0.03 }}
                            >
                              <input
                                type="checkbox"
                                id={`locid-${location.id}`}
                                value={location.id}
                                checked={selectedLocationIDs.includes(
                                  location.id
                                )}
                                onChange={() =>
                                  handleCheckboxChange(location.id)
                                }
                                className="mr-2 accent-green-600"
                              />
                              <label
                                htmlFor={`locid-${location.id}`}
                                className="text-gray-600"
                              >
                                {location.name}
                              </label>
                            </motion.div>
                          ))}
                        </div>
                      )}
                  </motion.div>
                ))
              ) : (
                <p className="font-QSemiBold text-gray-800 whitespace-nowrap">
                  No locations found.
                </p>
              )}
            </div>

            {apiError && (
              <div className="w-full text-center sm:text-right max-w-[100px]">
                <p
                  className="text-red-600 font-QSemiBold text-xs whitespace-nowrap text-ellipsis"
                  title={apiError}
                >
                  {apiError}
                </p>
              </div>
            )}

            <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
              <button
                onClick={onClose}
                disabled={isSubmitting}
                className={`px-4 py-2 border rounded-md transition ${
                  isSubmitting
                    ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                    : "text-gray-600 border-gray-300 hover:bg-gray-100"
                }`}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={isSubmitting}
                className={`px-4 py-2 rounded-md transition flex items-center justify-center ${
                  isSubmitting
                    ? "bg-blue-300 cursor-not-allowed text-white"
                    : "bg-blue-600 text-white hover:bg-blue-700"
                }`}
              >
                {isSubmitting ? (
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MultipleLocationSuperMarketModal;
